const { AllSocialMedia } = require("../features/admin/common/Slice");

exports.APIS = {
  Auth: "/common/auth/admin-login",
  ChangePassword: "/common/auth/change-password",

  Host: "/admin/host",
  Customer: "/admin/customer",
  RecordingList: "/admin/recording-list",
  Notification: "/admin/notification",
  Attendence: "/admin/attendence",
  AllRecordingInfo: "/admin/all-recording",

  Masters: {
    Week: "/admin/masters/week",
    Country: "/admin/masters/country",
    State: "/admin/masters/state",
    City: "/admin/masters/city",
    District: "/admin/masters/district",
    Pincode: "/admin/masters/pincode",
    Gender: "/admin/masters/gender",
    FAQ: "/admin/masters/faq",
    Occupation: "/admin/masters/occupation",
    Orientation: "/admin/masters/orientation",
    PrintingLocations: "/admin/masters/printing-locations",
    Materials: "/admin/masters/materials",
    Laminations: "/admin/masters/laminations",
    Shapes: "/admin/masters/shapes",
    Partners: "/admin/masters/partners",
    WhyChooseUs: "/admin/masters/whychooseus",
    Industry: "/admin/masters/industry",
    Department: "/admin/masters/department",
    CompanySize: "/admin/masters/companysize",
    Faq: "/admin/masters/faqs",
    SubFaq: "/admin/masters/subfaq",
    Qty: "/admin/masters/qty",
    Envelopes: "/admin/masters/envelopes",
    SocialMedia: "/admin/masters/socialmedia",
    Coupons: "/admin/masters/coupons",
  },

  // common
  Commons: {
    AllCountry: "/common/masters/all-country",
    AllState: "/common/masters/all-state",
    AllCity: "/common/masters/all-city",
    AllDistrict: "/common/masters/all-district",
    AllPincode: "/common/masters/all-pincode",
    AllCategory: "/common/masters/all-category",
    AllSubCategory: "/common/masters/all-subcategory",
    AllChildCategory: "/common/masters/all-childcategory",
    AllPartners: "/common/masters/all-partners",
    AllWhyChooseUs: "/common/masters/all-whychooseus",
    AllIndustry: "/common/masters/all-industry",
    AllDepartment: "/common/masters/all-department",
    AllCompanySize: "/common/masters/all-companysize",
    AllNeeds: "/common/masters/all-needs",
    AllFaq: "/common/masters/all-faqs",
    AllSubFaq: "/common/masters/all-subfaq",
    AllSocialMedia: "/common/masters/all-socialmedia",
    AllUserStatus: "/common/masters/all-user-status",
    AllHosts: "/common/masters/all-hosts",
    AllRoles: "/common/masters/all-roles",
  },

  //Customer
  Customer_Management: {
    customer: "/admin/customer-management/customer",
  },

  //Wallet
  Wallet: {
    wallet_history: "/admin/wallet/wallet-history",
    intrest_history: "/admin/wallet/intrest-history",
    commission_history: "/admin/wallet/commission-history",
    about_me: "/admin/wallet/about-me",
  },

  //Customization
  Customization: {
    AppSetUp: "/admin/customization/app-setup",
  },

  //Profile Feed
  ProfileFeed: {
    AboutUs: "/admin/profile-feed/about-us",
    TermsAndCondition: "/admin/profile-feed/terms-and-condition",
    PrivacyPolicy: "/admin/profile-feed/privacy-policy",
    RefundPolicy: "/admin/profile-feed/refund-policy",
  },

  FundRequest: {
    fundRequest: "/admin/fund-request",
  },

  WithdrawlRequest: {
    withdrawlRequest: "/admin/withdrawl-request",
  },

  // Dashboard
  Dashboard: {
    dashboard: "/admin/dashboard",
  },

  //Rating And Feedback
  RatingAndFeedback: {
    feedback: "/admin/rating/feedback",
  },
};
